import { addMonths, format } from 'date-fns'

// Display only: the API enforces the rule through Faq::RENOTIFICATION_COOLDOWN_MONTHS.
export const RENOTIFICATION_COOLDOWN_MONTHS = 3

const parseDate = (value) => {
  if (!value) return null
  const date = new Date(String(value).replace(' ', 'T'))
  return Number.isNaN(date.getTime()) ? null : date
}

export const formatRenotificationDate = (date) => date ? format(date, 'dd/MM/yyyy') : '—'

/**
 * Status of a question regarding manual renotification:
 * - `never`: never renotified, can be renotified;
 * - `available`: already renotified, can be renotified again;
 * - `blocked`: disabled question, or last renotification less than the cooldown ago.
 */
export const renotificationState = (question, now = new Date()) => {
  const data = question || {}
  const count = Number(data.renotifications_count) || 0
  const lastAt = parseDate(data.last_renotified_at)
  const availableAt = lastAt ? addMonths(lastAt, RENOTIFICATION_COOLDOWN_MONTHS) : null

  if (![true, 1, '1', 'true'].includes(data.is_enabled)) {
    return { count, lastAt, availableAt, status: 'blocked', blockedReason: 'Activez la question pour pouvoir la renotifier.' }
  }
  if (availableAt && availableAt > now) {
    return {
      count,
      lastAt,
      availableAt,
      status: 'blocked',
      blockedReason: `Nouvelle renotification possible à partir du ${formatRenotificationDate(availableAt)}.`
    }
  }
  return { count, lastAt, availableAt, status: count > 0 || lastAt ? 'available' : 'never', blockedReason: '' }
}
